api = require('../0_def.coffee')

api.factory 'api/Appointment/counts#factory', [
  'ksc.Record', 'ksc.RestList',
  (Record, RestList) ->
    ->
      new RestList
        endpoint:
          url: '/dashboard-calendar-ui/api/Appointment/counts'
        record:
          class: Record # read-only record
          contract:
            localDate: { type: 'number' }
            providerId: { type: 'number', nullable: true }
            resourceId: { type: 'number', nullable: true }
            serviceLocationId: { type: 'number' }
            count: { type: 'number' }
          idProperty: ['localDate', 'providerId', 'resourceId',
            'serviceLocationId']
]


api.service 'api/Appointment/counts', [
  'api/Appointment/counts#factory',
  (countsFactory) ->

# NOTE: It is the caller's responsbility to load this service with data
# parts and filter the results as needed (i.e. there may be multiple widgets
# using different parst of the data set)
# Do not ever treat this service as a container for your data only. If you
# want independently loaded data store, use the factory and instanciate
# your own.
    countsFactory()
]
